import {
  AdminEventEquipmentRequest,
  GetEquipment,
  OrganiserEquipment,
  OrganiserEventEquipmentRequest,
  QueryArgs,
} from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { privateAxios } from "../axiosInstances";
import {
  equipmentsQueryKeys,
  eventEquipmentRequestQueryKeys,
} from "../query-keys/equipments.query-keys";

async function getAdminEquipmentsQuery() {
  try {
    const { data } = await privateAxios.get<GetEquipment[]>(`/equipments`);
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        message: error.response?.data.message,
      };
    }
    throw error;
  }
}

export const useGetAdminEquipmentsQuery = () => {
  return useQuery({
    queryKey: equipmentsQueryKeys.lists(),
    queryFn: () => getAdminEquipmentsQuery(),
  });
};

async function getOrganiserEquipmentsQuery() {
  try {
    const { data } = await privateAxios.get<OrganiserEquipment[]>(`/equipments/organiser-specific`);
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        message: error.response?.data.message,
      };
    }
    throw error;
  }
}

export const useGetOrganiserEquipmentsQuery = () => {
  return useQuery({
    queryKey: equipmentsQueryKeys.lists(),
    queryFn: () => getOrganiserEquipmentsQuery(),
  });
};

const getEquipmentsRequestsQuery = async () => {
  try {
    const { data } = await privateAxios.get<AdminEventEquipmentRequest[]>(`/equipments/requests`);
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        message: error.response?.data.message,
      };
    }
    throw error;
  }
};

export const useGetEquipmentsRequestsQuery = <TData = AdminEventEquipmentRequest[]>(
  options?: QueryArgs<AdminEventEquipmentRequest[], TData>,
) => {
  return useQuery({
    queryKey: eventEquipmentRequestQueryKeys.lists(),
    queryFn: () => getEquipmentsRequestsQuery(),
    ...options,
  });
};

const getEventEquipmentRequestQuery = async (eventId: string) => {
  try {
    const { data } = await privateAxios.get<OrganiserEventEquipmentRequest[]>(
      `/equipments/requests/${eventId}`,
    );
    return data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw {
        message: error.response?.data.message,
      };
    }
    throw error;
  }
};

export const useGetEventEquipmentRequestQuery = <TData = OrganiserEventEquipmentRequest[]>(
  eventId: string,
  options?: QueryArgs<OrganiserEventEquipmentRequest[], TData>,
) => {
  return useQuery({
    queryKey: eventEquipmentRequestQueryKeys.list(eventId),
    queryFn: () => getEventEquipmentRequestQuery(eventId),
    ...options,
  });
};
